export const DYNAMIC_FILTER_PREFIX = 'dynamic_filter'

export const getFilterColumnId = (id = '') => `${DYNAMIC_FILTER_PREFIX}_${id}`
